/** Adam project package constants (sibling to Curva `.curva`). */
export const ADAM_FILE_EXTENSION = ".adam";
export const ADAM_MIME_TYPE = "application/vnd.adam+zip";

/** Full sample library package (folders + imported PCM). */
export const ADAM_SAMPLES_FILE_EXTENSION = ".adamsamples";
export const ADAM_SAMPLES_MIME_TYPE = "application/vnd.adam.samples+zip";
export const ADAM_SAMPLES_FORMAT = "adamsamples" as const;
export const ADAM_SAMPLES_PACKAGE_VERSION = 1 as const;

/** Package + project-wrapper format tag. */
export const ADAM_FORMAT = "adam" as const;
export const ADAM_PACKAGE_VERSION = 1 as const;

export const ADAM_PROJECT_JSON_PATH = "project.json";
export const ADAM_METADATA_JSON_PATH = "metadata.json";

export const ADAM_SAMPLES_METADATA_JSON_PATH = "metadata.json";
export const ADAM_SAMPLES_MANIFEST_JSON_PATH = "manifest.json";
export const ADAM_SAMPLES_FOLDERS_JSON_PATH = "folders.json";
export const ADAM_SAMPLES_AUDIO_DIR = "samples/";
